/** Pure HUD formatting helpers. */

/** 1234 → "1.2K", 2_500_000 → "2.5M". */
export function shortNumber(n: number): string {
  const a = Math.abs(n);
  if (a >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (a >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (a >= 1e4) return `${Math.round(n / 1e3)}K`;
  if (a >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return `${Math.round(n)}`;
}

/** ms → "m:ss" (or "h:mm:ss"). Negative values get a leading "-". */
export function clock(ms: number): string {
  const neg = ms < 0;
  const total = Math.floor(Math.abs(ms) / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const body = h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
  return neg ? `-${body}` : body;
}

/** Cooldown label: "12", "1.4" under 3 s, "2m" over 99 s. */
export function cooldownText(ms: number): string {
  if (ms <= 0) return '';
  if (ms < 3000) return (ms / 1000).toFixed(1);
  const s = Math.ceil(ms / 1000);
  return s > 99 ? `${Math.ceil(s / 60)}m` : `${s}`;
}

const pad = (n: number): string => (n < 10 ? `0${n}` : `${n}`);

/** "warden.shield_slam" / "Shield Slam" → "SS" for placeholder icons. */
export function initials(name: string): string {
  const words = name.replace(/^[a-z]+\./, '').split(/[\s_\-.]+/).filter(Boolean);
  return words
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('');
}

/** Upgrade label for a chest value. */
export function chestLabel(chest: 0 | 1 | 2 | 3 | null, completed: boolean): string {
  if (!completed) return 'Abandoned';
  if (!chest) return 'Depleted';
  return `+${chest}`;
}
